import {
    List,
    Datagrid,
    TextField,
    DateField,
    FunctionField,
    usePermissions
} from "react-admin";
import { apiUrl } from "../apiendpoint";
import { Typography, Box } from "@mui/material";

const CertificateAssignList =  (props) => {
    const { permissions = [] } = usePermissions();
   console.log("Permissions in CertificateAssignList:", permissions);

    return (
        <>

        <List title="Certificate" {...props}>
       <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Assign Certificate
        </Typography>
      </Box>
            <Datagrid rowClick={false}>
                
                <TextField source="user_email" label="Email" />
                <TextField source="course_name" label="Certificate-Type" />
                <DateField source="issued_at" label="Issued At" showTime />

                <FunctionField
                    label="PDF"
                    render={(record) =>
                        record.pdf_url ? (
                            <a
                                href={`${apiUrl}${record.pdf_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View PDF
                            </a>
                        ) : "-"
                    }
                />

                <FunctionField
                    label="Image"
                    render={(record) =>
                        record.image_url ? (
                            <a
                                href={`${apiUrl}${record.pdf_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View Image
                            </a>
                        ) : "-"
                    }
                />
            </Datagrid>
            
        </List>
     </>
    );
};

export default CertificateAssignList;